export default {"src":"/_next/static/media/MultipleChoiceConsent.6c10efe1.svg","height":16,"width":18,"blurWidth":0,"blurHeight":0};